import {
    contentTypeDataNewSite,
    contentTypeModelTypeNewSite,
} from './mo_content_type_new'

// main
export type contentTypeModelTypeSite = contentTypeModelTypeNewSite
export const contentTypeDataSite = {
    ...contentTypeDataNewSite,
}
